import React from 'react';

import UiList from '../../../modules/ui/ui-list/ui-list';

import './ucp-ontractors.scss';

interface UcpOntractorsProps {
  initiatorInfo: {
    name: string;
    inn: string;
  };
  recipient: {
    name: string;
    inn: string;
    requisites?: string;
    accountNumber?: string;
  };
}

const UcpOntractors: React.FC<UcpOntractorsProps> = ({
  initiatorInfo,
  recipient,
}) => {
  const initiatorList = [
    {
      label: 'Эмитент:',
      value: initiatorInfo.name,
    },
    {
      label: 'ИНН:',
      value: initiatorInfo.inn,
    },
  ];

  const recipientList = [
    {
      label: 'Приобретатель:',
      value: recipient.name,
    },
    {
      label: 'ИНН',
      value: recipient.inn,
    },
  ];

  const requisitesList = [
    {
      label: 'Реквизиты продавца:',
      value: recipient.requisites || '',
    },
    {
      label: 'Номер счета:',
      value: recipient.accountNumber || '',
    },
  ];

  return (
    <div className="ucp__ontractors">
      {/* <h3 className="h3">Стороны:</h3> */}
      <div className="ucp__ontractors-body">
        <div className="ucp__ontractors__left">
          <UiList list={initiatorList} sm />
        </div>
        <div className="ucp__ontractors__right">
          <UiList list={recipientList} sm />
        </div>
        <div className="ucp__ontractors__right">
          <UiList list={requisitesList} sm />
        </div>
      </div>
    </div>
  );
};

export default UcpOntractors;
